<template>
  <div
    class="user-notification-list-item list-group-item"
    :class="wrapperClass"
    @click.prevent="() => $core.$userNotificationsService.goToLink(notification)"
  >
    <!-- Display notification item as a list of app sidebar notification popover inner content with image and main links by the type NotificationListItemData-->
    <div class="d-flex">
      <div
        v-if="thumbImage"
        class="col"
        style="width: 32px; max-width: 32px; padding-right: 0"
      >
        <img
          :src="thumbImage"
          class="img-fluid rounded-circle"
          alt="icon"
        />
      </div>
      <div class="col">
        <div>
          <UserNotificationDataListItem
            :item="notification"
            class="user-notification-data-list-item--in-popover"
          />
          <div class="user-notification-list-item--attrs">
            <!-- notification.createdAt with relative display -->
            <span class="user-notification-list-item--attrs-item">{{
              createdAtDisplay
            }}</span>
            <span
              class="user-notification-list-item--attrs-item"
              v-if="notification.category"
              >{{ notification.category }}</span
            >
            <span
              class="user-notification-list-item--attrs-item"
              v-if="notification.categorySub"
              >{{ notification.categorySub }}</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { PropType } from 'vue'
import { ModelCoreUserNotification } from '../models/ModelCoreUserNotifications'

import UserNotificationDataListItem from './UserNotificationDataListItem.vue'
// type定義 NotificationListItemData に従った、ダミーデータ
export default {
  name: 'UserNotificationListItemInPopover',
  components: {
    UserNotificationDataListItem,
  },
  props: {
    notification: {
      type: Object as PropType<ModelCoreUserNotification>,
      required: true,
    },
    notReloading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      popoverShow: true,
    }
  },
  computed: {
    wrapperClass() {
      return this.notReloading
        ? {}
        : {
            unread: !this.notification.readAt,
            'user-notification-list-item--read': !!this.notification.readAt,
            linkable: !!this.notification.hasLink,
          }
    },
    createdAtDisplay() {
      return this.$core.$dayjs(this.notification.createdAt).fromNow()
    },
    thumbImage() {
      return false
    },
    hasLink() {
      return !!this.notification?.linkUrl
    },
    bodyTextTrimmed() {
      const body = this.notification.body || ''
      if (body.length > 100) {
        return body.substring(0, 100) + '...'
      }
      return body
    },
  },
  methods: {},
}
</script>
